import ViewLinks from "./ViewLinks/ViewLinks";
import SortBooksButton from "./SortBooksButton/SortBooksButton";
import { LetterbookSettingType } from "features/Letterbooks/types";

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function LetterbooksControls({
  settings,
}: LetterbookOptions) {
  return (
    <nav className="flex flex-row justify-between">
      <div>
        {/* <FilterBooksButton context={context} /> */}
        <SortBooksButton settings={settings} />
      </div>

      <ViewLinks settings={settings} />
    </nav>
  );
}
